var _defs, _rect, _text, _rect2, _text2, _g, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalhub({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 340",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hubBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#022c22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#064e3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0b0f19"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 340,
    fill: "url(#hubBg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 48,
    fill: "#f8fafc",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 20,
    fontWeight: 800,
    letterSpacing: -0.5
  }, "LocalHub Platform")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 32,
    width: 120,
    height: 22,
    rx: 11,
    fill: "rgba(16,185,129,0.15)",
    stroke: "rgba(16,185,129,0.3)",
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 47,
    fill: "#34d399",
    fontFamily: "monospace",
    fontSize: 11,
    fontWeight: 600,
    textAnchor: "middle"
  }, "localhub.site")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 75)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 155,
    height: 85,
    rx: 8,
    fill: "#0f172a",
    stroke: "rgba(6,182,212,0.4)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 26,
    fill: "#06b6d4",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 700
  }, "YAFT"), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 46,
    fill: "#94a3b8",
    fontFamily: "system-ui",
    fontSize: 10
  }, "Finance &amp; Ledger"), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 68,
    fill: "#34d399",
    fontFamily: "monospace",
    fontSize: 11
  }, "\u25CF Active :3001"), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 0,
    width: 155,
    height: 85,
    rx: 8,
    fill: "#0f172a",
    stroke: "rgba(168,85,247,0.4)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 189,
    y: 26,
    fill: "#c084fc",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 700
  }, "PGHandle"), /*#__PURE__*/React.createElement("text", {
    x: 189,
    y: 46,
    fill: "#94a3b8",
    fontFamily: "system-ui",
    fontSize: 10
  }, "Property Cloud"), /*#__PURE__*/React.createElement("text", {
    x: 189,
    y: 68,
    fill: "#34d399",
    fontFamily: "monospace",
    fontSize: 11
  }, "\u25CF Active :5174"), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 0,
    width: 150,
    height: 85,
    rx: 8,
    fill: "#0f172a",
    stroke: "rgba(99,102,241,0.4)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 364,
    y: 26,
    fill: "#818cf8",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 700
  }, "KnowledgeShelf"), /*#__PURE__*/React.createElement("text", {
    x: 364,
    y: 46,
    fill: "#94a3b8",
    fontFamily: "system-ui",
    fontSize: 10
  }, "Learning Engine"), /*#__PURE__*/React.createElement("text", {
    x: 364,
    y: 68,
    fill: "#34d399",
    fontFamily: "monospace",
    fontSize: 11
  }, "\u25CF Active :5180"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 105,
    width: 240,
    height: 70,
    rx: 8,
    fill: "#0f172a",
    stroke: "rgba(245,158,11,0.4)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 130,
    fill: "#fbbf24",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 700
  }, "MinIO S3 Storage"), /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 152,
    fill: "#94a3b8",
    fontFamily: "system-ui",
    fontSize: 11
  }, "Object Buckets &amp; Assets (:9001)"), /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 105,
    width: 240,
    height: 70,
    rx: 8,
    fill: "#0f172a",
    stroke: "rgba(59,130,246,0.4)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 274,
    y: 130,
    fill: "#60a5fa",
    fontFamily: "monospace",
    fontSize: 13,
    fontWeight: 700
  }, "API Gateway &amp; Docs"), /*#__PURE__*/React.createElement("text", {
    x: 274,
    y: 152,
    fill: "#94a3b8",
    fontFamily: "system-ui",
    fontSize: 11
  }, "OpenAPI / Swagger Routing"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 315,
    fill: "#64748b",
    fontFamily: "monospace",
    fontSize: 11
  }, "Microservice Router \u2022 Domain Proxy \u2022 Service Discovery Hub")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalhub);
export default __webpack_public_path__ + "static/media/localhub.beb5b1b9fd8ae968e14a37676a333822.svg";
export { ForwardRef as ReactComponent };